import LogisticsTab from './LogisticsTab';
export default LogisticsTab;